import { AUTH_STRATEGY, ParsedDecodedToken } from "@dashboard/library";

export enum AUTHENTICATION_STATUS {
  AUTHENTICATED = "AUTHENTICATED",
  NOT_AUTHENTICATED = "NOT_AUTHENTICATED",
  UNKNOWN = "UNKNOWN",
}

export enum AUTH_STATES {
  REFRESH_TOKEN = "refreshToken",
  SIGN_IN_SUCCESS = "signInSuccess",
  SIGN_IN_ERROR = "signInError",
  SIGN_OUT = "signOut",
}

export interface AuthenticationState {
  /** Authentication status of the user */
  status: AUTHENTICATION_STATUS;

  /** Error message the user get while signing in */
  signedInError: string | null;

  /** Strategy used to sign in */
  signedInStrategy: AUTH_STRATEGY | null;

  /** Whether the user is signed in using impersonate_token cookie */
  isConnectedAs: boolean;

  /** User auth token */
  token: string | null;

  /** Decoded token */
  decodedToken?: ParsedDecodedToken;

  /** Whether the user is only an agent */
  isAgent: boolean;
}

export interface AuthenticationContext {
  authState: AuthenticationState;
  actions: {
    onSessionExpired: VoidFunction;
    refreshToken: RefreshToken;
    setSignInError: (message: string | null) => void;
  };
}

export type AuthenticationActionType =
  | { type: AUTH_STATES.REFRESH_TOKEN; payload: { token: string } }
  | {
      type: AUTH_STATES.SIGN_IN_SUCCESS;
      payload: {
        token: string;
        isConnectedAs: boolean;
        decodedToken?: ParsedDecodedToken;
        strategy: AUTH_STRATEGY;
        isAgent: boolean;
      };
    }
  | {
      type: AUTH_STATES.SIGN_IN_ERROR;
      payload: { message: string | null; strategy: AUTH_STRATEGY };
    }
  | { type: AUTH_STATES.SIGN_OUT };

export type RefreshToken = () => Promise<void>;

export enum SAME_SITE_TYPE {
  NONE = "none",
}
